import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Index from './pages/index';
import IndexThree from './pages/index/index-three';
import IndexFour from './pages/index/index-four';
import IndexTwo from './pages/index/index-two';
import IndexFive from './pages/index/index-five';
import IndexSix from './pages/index/index-six';
import IndexSeven from './pages/index/index-seven';
import IndexEight from './pages/index/index-eight';
import IndexNine from './pages/index/index-nine';
import IndexTen from './pages/index/index-ten';
import IndexEleven from './pages/index/index-eleven';
import Video from './pages/index/video';
import Map from './pages/index/map';
import ListLayoutOne from './pages/property/list-layout-one';
import ListLayoutTwo from './pages/property/list-layout-two';
import ScrollToTop from './components/scroll-to-top';
import ListLayoutThree from './pages/property/list-layout-three';
import ListLayoutWithMap from './pages/property/list-layout-with-map';
import ListLayoutFull from './pages/property/list-layout-full';
import GridLayoutWithSidebar from './pages/property/grid-layout-with-sidebar';
import ClassicalLayoutWithSidebar from './pages/property/classical-layout-with-sidebar';
import GridLayoutWithMap from './pages/property/grid-layout-with-map';
import Grid from './pages/property/grid';
import ClassicalProperty from './pages/property/classical-property';
import ClassicalLayoutWithMap from './pages/property/classical-layout-with-map';
import HalfMap from './pages/property/half-map';
import HalfMapTwo from './pages/property/half-map-2';
import SinglePropertyOne from './pages/property/single-property-1';
import SinglePropertyTwo from './pages/property/single-property-2';
import SinglePropertyThree from './pages/property/single-property-3';
import SinglePropertyFour from './pages/property/single-property-4';
import Agents from './pages/agents/agents';
import AgentPage from './pages/agents/agent-page';
import Agencies from './pages/agents/agencies';
import AgencyPage from './pages/agents/agency-page';
import AddAgent from './pages/agents/add-agent';
import AddInm from './pages/agents/add-inm';
import AddAso from './pages/agents/add-aso';
import SubmitProject from './pages/property/submit-project';
import Dashboard from './pages/admin/dashboard';
import Payment from './pages/admin/payment';
import MyProfile from './pages/admin/my-profile';
import MyProperty from './pages/admin/my-property';
import BookmarkList from './pages/admin/bookmark-list';
import ChangePassword from './pages/admin/change-password';
import CompareProperty from './pages/property/compare-property';
import SubmitProperty from './pages/property/submit-property-NUEVO';
import Blog from './pages/blog/blog';
import BlogDetail from './pages/blog/blog-detail';
import Component from './pages/component';
import Pricing from './pages/pricing';
import Error from './pages/error';
import Contact from './pages/contact';
import AboutUs from './pages/about-us';
import Checkout from './pages/admin/checkout';
import CreateAccount from './pages/admin/create-account';
import EditAgent from './pages/agents/edit-agent';
import Faq from './pages/faq';
import Beneficios from './pages/beneficios/Beneficios';
import Zonas from './pages/zonas/Zonas';
import ZonaDetail from './pages/zonas/ZonaDetail';
import Certificacion from './pages/certificacion/Certificacion';
import SubmitPropertyDashboard from './pages/admin/submit-property-dashboard';
import TestFirebase from './components/TestFirebase';
import FirebaseStorageTest from './components/FirebaseStorageTest';
import AMPIMigration from './components/AMPIMigration';
import AMPIMigrationOptimized from './components/AMPIMigrationOptimized';
import MigracionOptimizada from './components/MigracionOptimizada';
import CorreccionPropiedades from './components/CorreccionPropiedades';
import AnalizarGruposPropiedades from './components/AnalizarGruposPropiedades';
import EliminarPropiedadesDuplicadas from './components/EliminarPropiedadesDuplicadas';
import AgregarCampoTipo from './components/AgregarCampoTipo';
import DatabaseAnalysis from './components/DatabaseAnalysis';
import DatabaseCleanup from './components/DatabaseCleanup';
import IntegrityValidator from './components/IntegrityValidator';
import MigrationResume from './components/MigrationResume';
import PropertyDataChecker from './components/PropertyDataChecker';
import PropertyLinker from './components/PropertyLinker';
import PasswordResetManager from './components/PasswordResetManager';
import PropertyAssignmentManager from './components/PropertyAssignmentManager';
import DataSyncAnalyzer from './components/DataSyncAnalyzer';
import PropertyAnalyzer from './components/PropertyAnalyzer';
import FixFirebaseAccounts from './pages/admin/fix-firebase-accounts';
import FixFirebaseAccountsBatch from './pages/admin/fix-firebase-accounts-batch';
import FixMissingFirestoreUsers from './pages/admin/fix-missing-firestore-users';
import AsignarPropiedadesMiriam from './pages/admin/asignar-propiedades-miriam';
import AsignacionMasivaPropiedades from './pages/admin/asignacion-masiva-propiedades';
import DiagnosticoPropiedades from './pages/admin/diagnostico-propiedades';
import ActualizarNombresFlex from './pages/admin/actualizar-nombres-flex';
import ReporteAsignaciones from './pages/admin/reporte-asignaciones';
import PropertyCleanupManager from './pages/admin/property-cleanup-manager';
import PropertyManualLinker from './pages/admin/property-manual-linker';
import PropertyAgencyAssignerPage from './pages/admin/property-agency-assigner';
// import MigrationAudit from './components/MigrationAudit';
import CreateTaller from './pages/admin/create-taller';
import Calificacion from './pages/agents/calificacion';
import ClientOne from './components/client-one';
import Asociados from '../src/pages/agents/asociados';
import { UserProvider } from './context/UserContext';
import { ToastContainer } from 'react-toastify';
import AsociadoPage from './pages/agents/asociado-page';
import EditInmobiliaria from './pages/admin/editar-inm';
import 'react-toastify/dist/ReactToastify.css';
import './assets/css/navigation-fixes.css';
import VerTalleres from './pages/admin/ver-taller';
import AdminTalleres from './pages/admin/admin-talleres';
import PrivateRoute from './pages/admin/privateroute';
import EditTaller from './pages/admin/edit-taller';
import ProjectList from './pages/agents/project-list'
import VerTallerInd from './pages/admin/ver-taller-individual';
import ViewProject from './pages/agents/view-project';
import { Link } from 'react-router-dom';
import MyProject from './pages/admin/my-project';
import ViewProperty from './pages/admin/view-property';
import AprobarPropiedades from './pages/admin/aprobar-propiedades';
import MisCursos from './pages/admin/mis-cursos';
import ScannAsistenia from './pages/admin/escanear-asistencia';
import AdminDashboard from './pages/admin/admin-dashboard';
import AprobarResena from './pages/admin/aprobar-resena';
import AdminInm from './pages/admin/admin-inm';
import VerInm from './pages/admin/ver-inm';
import AddAdmin from './pages/admin/add-admin';
import AdminProject from './pages/admin/admin-project';
import VerProject from './pages/admin/ver-project';
import EditProject from './pages/admin/edit-project';
import AdminProperty from './pages/admin/admin-property';
import ViewAdminProperty from './pages/admin/view-admin-property';
import EditProperty from './pages/admin/edit-property-NUEVO';
import AdminAfiliado from './pages/admin/admin-afiliado';
import VerAdminAfiliado from './pages/admin/ver-admin-afiliado';
import EditarAfiliado from './pages/admin/editar-afiliado';
import VerAdminAsociado from './pages/admin/ver-admin-asociado';
import AdminAsociado from './pages/admin/admin-asociado';
import EditarAsociado from './pages/admin/editar-asociado';
import AdminAsignaciones from './pages/admin/admin-asignaciones';
import InscripcionCurso from './pages/admin/ins-taller';
import InscripcionCursoPublico from './pages/agents/inscripcion-publica';
import SeleccionarRol from './pages/admin/seleccionar-rol';
import AdminComiteDashboard from './pages/admin/admin-comite-dashboard';
import VerificarInmobiliariasNuevas from './pages/admin/verificar-inmobiliarias-nuevas';
import MigrarNuevosMiembros from './pages/admin/migrar-nuevos-miembros';
import MisLeads from './pages/admin/mis-leads';
import MLSSyncDashboard from './pages/admin/mls-sync-dashboard';
import ErrorBoundary from './components/error-boundary';

// Centro de Ayuda
import HelpCenter from './pages/help/HelpCenter';
import HelpSection from './pages/help/HelpSection';
import HelpArticle from './pages/help/HelpArticle';
import HelpFAQ from './pages/help/HelpFAQ';
import HelpGlossary from './pages/help/HelpGlossary';

function App() {
  return (

    <>
      <ErrorBoundary>
      <UserProvider>
      <ToastContainer /> {/* ✅ Aquí va, fuera de Routes */}
      <Routes>
        <Route path='/' element={<Index/>}/>
        <Route path='/home-2' element={<IndexTwo/>}/>
        <Route path='/home-3' element={<IndexThree/>}/>
        <Route path='/home-4' element={<IndexFour/>}/>
        <Route path='/home-5' element={<IndexFive/>}/>
        <Route path='/home-6' element={<IndexSix/>}/>
        <Route path='/home-7' element={<IndexSeven/>}/>
        <Route path='/home-8' element={<IndexEight/>}/>
        <Route path='/home-9' element={<IndexNine/>}/>
        <Route path='/home-10' element={<IndexTen/>}/>
        <Route path='/home-11' element={<IndexEleven/>}/>
        <Route path='/video' element={<Video/>}/>
        <Route path='/map' element={<Map/>}/>
        <Route path='/firebase-test' element={<TestFirebase />} />
        <Route path='/storage-test' element={<FirebaseStorageTest />} />
        <Route path='/ampi-migration' element={<AMPIMigration />} />
        <Route path='/ampi-migration-v2' element={<AMPIMigrationOptimized />} />
        <Route path='/ampi-migration-optimized' element={<AMPIMigrationOptimized />} />
        <Route path='/migracion-optimizada' element={<MigracionOptimizada />} />
        <Route path='/correccion-propiedades' element={<CorreccionPropiedades />} />
        <Route path='/analizar-grupos-propiedades' element={<AnalizarGruposPropiedades />} />
        <Route path='/eliminar-propiedades-duplicadas' element={<EliminarPropiedadesDuplicadas />} />
        <Route path='/agregar-campo-tipo' element={<AgregarCampoTipo />} />
        <Route path='/database-analysis' element={<DatabaseAnalysis />} />
        <Route path='/database-cleanup' element={<DatabaseCleanup />} />
        <Route path='/integrity-validator' element={<IntegrityValidator />} />
        <Route path='/migration-status' element={<MigrationResume />} />
        <Route path='/migration-resume' element={<MigrationResume />} />
        <Route path='/property-data-checker' element={<PropertyDataChecker />} />
        <Route path='/property-linker' element={<PropertyLinker />} />
        <Route path='/admin-password-reset-manager' element={<PasswordResetManager />} />
        <Route path='/admin-property-assignment-tools' element={<PropertyAssignmentManager propertyId="" />} />
        <Route path='/admin-data-sync-analyzer' element={<DataSyncAnalyzer />} />
        <Route path='/admin-property-analyzer' element={<PropertyAnalyzer />} />
        <Route path='/admin-fix-firebase-accounts' element={<FixFirebaseAccounts />} />
        <Route path='/admin-fix-firebase-accounts-batch' element={<FixFirebaseAccountsBatch />} />
        <Route path='/admin-fix-missing-firestore-users' element={<FixMissingFirestoreUsers />} />
        <Route path='/admin-asignar-propiedades-miriam' element={<AsignarPropiedadesMiriam />} />
        <Route path='/admin-asignacion-masiva-propiedades' element={<AsignacionMasivaPropiedades />} />
        <Route path='/admin-diagnostico-propiedades' element={<DiagnosticoPropiedades />} />
        <Route path='/admin-actualizar-nombres-flex' element={<ActualizarNombresFlex />} />
        <Route path='/admin-reporte-asignaciones' element={<ReporteAsignaciones />} />
        <Route path='/admin-property-cleanup' element={<PropertyCleanupManager />} />
        <Route path='/admin-property-manual-linker' element={<PropertyManualLinker />} />
        <Route path='/admin-property-agency-assigner' element={<PropertyAgencyAssignerPage />} />
        {/* <Route path='/migration-audit' element={<MigrationAudit />} /> */}
        <Route path='/list-layout-one' element={<ListLayoutOne/>}/>
        <Route path='/list-layout-two' element={<ListLayoutTwo/>}/>
        <Route path='/list-layout-three' element={<ListLayoutThree/>}/>
        <Route path='/list-layout-with-map' element={<ListLayoutWithMap/>}/>
        <Route path='/list-layout-full' element={<ListLayoutFull/>}/>
        <Route path='/grid-layout-with-sidebar' element={<GridLayoutWithSidebar/>}/>
        <Route path='/classical-layout-with-sidebar' element={<ClassicalLayoutWithSidebar/>}/>
        <Route path='/grid-layout-with-map' element={<GridLayoutWithMap/>}/>
        <Route path='/grid' element={<Grid/>}/>
        <Route path='/classical-property' element={<ClassicalProperty/>}/>
        <Route path='/classical-layout-with-map' element={<ClassicalLayoutWithMap/>}/>
        <Route path='/half-map' element={<HalfMap/>}/>
        <Route path='/half-map-2' element={<HalfMapTwo/>}/>
        <Route path='/single-property-1' element={<SinglePropertyOne/>}/>
        <Route path='/single-property-1/:id' element={<SinglePropertyOne/>}/>
        <Route path='/view-property/:id' element={<SinglePropertyOne/>}/>
        <Route path='/edit-property/:id' element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} showError={true}>
            <EditProperty/>
          </PrivateRoute>
        }/>
        <Route path='/single-property-2' element={<SinglePropertyTwo/>}/>
        <Route path='/single-property-2/:id' element={<SinglePropertyTwo/>}/>
        <Route path='/single-property-3' element={<SinglePropertyThree/>}/>
        <Route path='/single-property-3/:id' element={<SinglePropertyThree/>}/>
        <Route path='/single-property-4' element={<SinglePropertyFour/>}/>
        <Route path='/single-property-4/:id' element={<SinglePropertyFour/>}/>
        <Route path='/agents' element={<Agents/>}/>
        <Route path='/agent-page' element={<AgentPage/>}/>
        <Route path='/agent-page/:id' element={<AgentPage/>}/>
        <Route path='/agencies' element={<Agencies/>}/>
        <Route path='/agency-page' element={<AgencyPage/>}/>
        <Route path='/agency-page/:id' element={<AgencyPage/>}/>
        <Route path='/add-agent' element={<AddAgent/>}/>
        <Route path='/add-inm' element={<AddInm/>}/>
        <Route path='/add-aso' element={<AddAso/>}/>
        <Route path='/dashboard' element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} permission="access-dashboard" showError={true}>
            <Dashboard/>
          </PrivateRoute>
        }/>
        <Route path='/payment' element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} showError={true}>
            <Payment/>
          </PrivateRoute>
        }/>
        <Route path='/my-profile' element={
          <PrivateRoute roles={['ASOCIADO', 'AFILIADO']} permission="edit-profile" showError={true}>
            <MyProfile/>
          </PrivateRoute>
        }/>
        <Route path='/my-property' element={
          <PrivateRoute roles={['ASOCIADO', 'AFILIADO']} permission="view-my-properties" showError={true}>
            <MyProperty/>
          </PrivateRoute>
        }/>
        <Route path='/my-project' element={
          <PrivateRoute roles={['ASOCIADO', 'AFILIADO']} permission="view-my-projects" showError={true}>
            <MyProject/>
          </PrivateRoute>
        }/>
        <Route path='/mis-cursos' element={
          <PrivateRoute roles={['ASOCIADO', 'AFILIADO']} showError={true}>
            <MisCursos/>
          </PrivateRoute>
        }/>
        <Route path='/mis-leads' element={
          <PrivateRoute roles={['ASOCIADO', 'AFILIADO']} showError={true}>
            <MisLeads/>
          </PrivateRoute>
        }/>
        <Route path='/bookmark-list' element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} showError={true}>
            <BookmarkList/>
          </PrivateRoute>
        }/>
        <Route path='/change-password' element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} showError={true}>
            <ChangePassword/>
          </PrivateRoute>
        }/>
        <Route path='/compare-property' element={<CompareProperty/>}/>
        <Route path='/submit-property' element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="create-property" showError={true}>
            <SubmitProperty/>
          </PrivateRoute>
        }/>
        <Route path='/submit-project' element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} showError={true}>
            <SubmitProject/>
          </PrivateRoute>
        }/>
        <Route path='/blog' element={<Blog/>}/>
        <Route path='/blog-detail' element={<BlogDetail/>}/>
        <Route path='/blog-detail/:id' element={<BlogDetail/>}/>
        <Route path='/component' element={<Component/>}/>
        <Route path='/pricing' element={<Pricing/>}/>
        <Route path='/404' element={<Error/>}/>
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/about-us' element={<AboutUs/>}/>
        <Route path='/beneficios' element={<Beneficios/>}/>
        <Route path='/zonas' element={<Zonas/>}/>
        <Route path='/zonas/:slug' element={<ZonaDetail/>}/>
        <Route path='/certificacion' element={<Certificacion/>}/>
        <Route path='/checkout' element={<Checkout/>}/>
        <Route path='/create-account' element={<CreateAccount/>}/>
        <Route path='/admin-create-taller' element={
          <PrivateRoute roles={['ADMIN']} permission="create-course" showError={true} allowAdminComite={true}>
            <CreateTaller/>
          </PrivateRoute>
        }/>
        <Route path='/place-search' element={<HalfMapTwo/>}/>
        <Route path='/submit-property-dashboard' element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="create-property" showError={true}>
            <SubmitPropertyDashboard/>
          </PrivateRoute>
        }/>
        <Route path='/calificacion' element={<Calificacion/>}/>
        <Route path='/asociados' element={<Asociados/>}/>
        <Route path='/asociado-page' element={<AsociadoPage/>}/>
        <Route path="/asociado-page/:id" element={<AsociadoPage />} />
        <Route path="/ver-taller" element={<VerTalleres />} />
        <Route path="/admin-talleres" element={
          <PrivateRoute roles={['ADMIN']} permission="manage-all-courses" showError={true} allowAdminComite={true}>
            <AdminTalleres />
          </PrivateRoute>
        } />
        <Route path="/edit-taller/:id" element={
          <PrivateRoute roles={['ADMIN']} permission="edit-course" showError={true} allowAdminComite={true}>
            <EditTaller />
          </PrivateRoute>
        } />
        <Route path="/ver-taller-ind/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} permission="view-course" showError={true} allowAdminComite={true}>
            <VerTallerInd />
          </PrivateRoute>
        } />
        <Route path="/edit-inmobiliaria/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} showError={true}>
            <EditInmobiliaria />
          </PrivateRoute>
        } />
        <Route path="/project-list" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} permission="view-my-projects" showError={true}>
            <ProjectList />
          </PrivateRoute>
        } />
        <Route path="/view-project/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} permission="view-project" showError={true}>
            <ViewProject />
          </PrivateRoute>
        } />
        <Route path="/my-project" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="view-my-projects" showError={true}>
            <MyProject />
          </PrivateRoute>
        } />
        <Route path="/view-property/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} permission="manage-property" showError={true}>
            <ViewProperty />
          </PrivateRoute>
        } />
        <Route path="/aprobar-propiedades" element={
          <PrivateRoute roles={['ADMIN']} permission="approve-properties" showError={true}>
            <AprobarPropiedades />
          </PrivateRoute>
        } />
        <Route path="/mis-cursos" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} permission="view-courses" showError={true}>
            <MisCursos />
          </PrivateRoute>
        } />
        <Route path="/escanear-asistencia" element={
          <PrivateRoute roles={['ADMIN']} permission="scan-attendance" showError={true} allowAdminComite={true}>
            <ScannAsistenia />
          </PrivateRoute>
        } />
        <Route path="/admin-dashboard" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <AdminDashboard />
          </PrivateRoute>
        } />
        <Route path="/aprobar-resena" element={
          <PrivateRoute roles={['ADMIN']} permission="approve-reviews" showError={true}>
            <AprobarResena />
          </PrivateRoute>
        } />
        <Route path="/admin-inm" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="manage-all-agencies" showError={true}>
            <AdminInm />
          </PrivateRoute>
        } />
        <Route path="/ver-inm/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="edit-agency" showError={true}>
            <VerInm />
          </PrivateRoute>
        } />
        <Route path="/add-admin" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <AddAdmin />
          </PrivateRoute>
        } />
        <Route path="/admin-project" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="manage-all-projects" showError={true}>
            <AdminProject />
          </PrivateRoute>
        } />
        <Route path="/ver-project/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="view-project" showError={true}>
            <VerProject />
          </PrivateRoute>
        } />
        <Route path="/edit-project/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="edit-projects" showError={true}>
            <EditProject />
          </PrivateRoute>
        } />
        <Route path="/admin-property" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="manage-all-properties" showError={true}>
            <AdminProperty />
          </PrivateRoute>
        } />
        <Route path="/view-admin-property/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} permission="manage-property" showError={true}>
            <ViewAdminProperty />
          </PrivateRoute>
        } />
        <Route path="/edit-property/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} permission="edit-property" showError={true}>
            <EditProperty />
          </PrivateRoute>
        } />
        <Route path="/admin-afiliado" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="manage-all-affiliates" showError={true}>
            <AdminAfiliado />
          </PrivateRoute>
        } />
        <Route path="/edit-agent/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="create-affiliate" showError={true}>
            <EditAgent />
          </PrivateRoute>
        } />
        <Route path="/ver-admin-afiliado/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} showError={true}>
            <VerAdminAfiliado />
          </PrivateRoute>
        } />
        <Route path="/editar-afiliado/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} showError={true}>
            <EditarAfiliado />
          </PrivateRoute>
        } />
        <Route path="/admin-asociado" element={
          <PrivateRoute roles={['ADMIN']} permission="manage-all-associates" showError={true}>
            <AdminAsociado />
          </PrivateRoute>
        } />
        <Route path="/ver-admin-asociado/:id" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <VerAdminAsociado />
          </PrivateRoute>
        } />
        <Route path="/editar-asociado/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} showError={true}>
            <EditarAsociado />
          </PrivateRoute>
        } />
        <Route path="/admin-asignaciones" element={
          <PrivateRoute roles={['ADMIN']} permission="manage-assignments" showError={true}>
            <AdminAsignaciones />
          </PrivateRoute>
        } />
        <Route path="/ins-taller" element={<InscripcionCurso />} />
        <Route path="/ins-taller/:tallerId" element={<InscripcionCurso />} />
        <Route path="/inscripcion-publica" element={<InscripcionCursoPublico />} />

        {/* Rutas para Admin de Comité */}
        <Route path="/seleccionar-rol" element={<SeleccionarRol />} />
        <Route path="/admin-comite/dashboard" element={<AdminComiteDashboard />} />

        {/* Rutas compartidas para Admin de Comité (acceso a talleres) */}
        <Route path="/create-taller" element={<CreateTaller />} />

        {/* Herramienta de verificación de inmobiliarias nuevas */}
        <Route path="/verificar-inmobiliarias-nuevas" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <VerificarInmobiliariasNuevas />
          </PrivateRoute>
        } />

        {/* Herramienta de migración de nuevos miembros */}
        <Route path="/migrar-nuevos-miembros" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <MigrarNuevosMiembros />
          </PrivateRoute>
        } />

        {/* Dashboard de sincronización MLS */}
        <Route path="/admin-mls-sync" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <MLSSyncDashboard />
          </PrivateRoute>
        } />

        {/* Centro de Ayuda - Rutas públicas */}
        <Route path="/ayuda" element={<HelpCenter />} />
        <Route path="/ayuda/seccion/:sectionId" element={<HelpSection />} />
        <Route path="/ayuda/articulo/:articleId" element={<HelpArticle />} />
        <Route path="/ayuda/faq" element={<HelpFAQ />} />
        <Route path="/ayuda/glosario" element={<HelpGlossary />} />

      </Routes>


        </UserProvider>
      </ErrorBoundary>
      <ScrollToTop />
    </>
  );
}

export default App;
